// Dataset / field-component intent handlers.

import { INTENTS } from '@store/intents';
import { params } from '@store/instance';
import { switchDataset, switchFieldComponent } from '../datasetManager';
import type { Store } from '@store/store';
import type { State } from '@store/schema';
import type { ViewerContext } from '../context';

export function register(store: Store<State>, viewer: ViewerContext): Array<() => void> {
    const offs: Array<() => void> = [];

    offs.push(store.onIntent(INTENTS.SET_FIELD_COMPONENT, (p) => {
        if (!p || typeof p.component !== 'string') return;
        params.fieldComponent = p.component;
        switchFieldComponent(viewer, p.component);
    }));

    offs.push(store.onIntent(INTENTS.SWITCH_DATASET, (p) => {
        if (!p || typeof p.key !== 'string') return;
        params.dataset = p.key;
        switchDataset(viewer, p.key);
    }));

    return offs;
}
